import type { FaireProductEntity } from "../../entity_types/product";

export const p_eh2vb55544: FaireProductEntity = {
  token: "p_eh2vb55544",
  type: "product",
  name: "Handwoven blue eyes tassel pendant devil's eye pendant",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/64af0a1a5a957a0b3a63bbc5aea28321a2d65d8f0d2d949b7dd6fb44c60729b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/345fd88b3142ba086ef6330da7d5d58185adcfbf233179cbedf8075eb7f70e93.jpeg",
    "https://cdn.faire.com/fastly/bed843e7684e19690e6166d8414927a7ecbbb3eaeda480edbebdf5b4375dc807.jpeg",
    "https://cdn.faire.com/fastly/42cae08e853e1c25953b16d99160a5c0ea614447c38c957b6db038a35c24d192.jpeg",
  ],
  priceDollars: 9.15,
  description:
    '"Large Pendant Size - 3.5*5cm\n\nEmbrace mystique with our Handwoven Blue Eyes Tassel Pendant, featuring a Devil\'s Eye design. This unique accessory seamlessly blends handcrafted elegance with an enigmatic touch. The captivating blue eyes and tassel pendant create a statement piece, adding an intriguing flair to your jewelry collection. Elevate your style with this extraordinary pendant.\n\nADORABLE & TRENDY! Offer many hours of enjoyment for Store！💜\n🎄💗\nHow cute are these Items! These make GREAT gifts💝! \n🎀Gift Idea | Gifts Store\n\n❤️ Thank you so much for love & support ❤️\n\n•✈️ After your order is placed, we ship in 7 - 9 business days.✈️\n•❤️ All shipping comes with Tracking Numbers.🧡\n\n💌 However, your satisfaction is our first priority so please feel free to contact us if you have any question about your order.\n\n**Please note these items are Manual Measurement, Measurements are approximate.\n**Any props seen in photo are not available for sale."',
  tags: [],
  msrpDollars: 18.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:55.141Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
